//
//
//
//
//
//
//
//


import ServiceObjectMaintenanceNotesTable from '../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTable.vue'

export default {
  components: {
    ServiceObjectMaintenanceNotesTable
  },
  props: {
    serviceObject: {
      type: Object,
      default: function () {
        return null
      }
    },
    useMobileLayout: {
      type: Boolean,
      default: false
    }
  }
}
